<template>
  <div>
    <a-row class="mb-10">
      <a-table
        bordered
        :pagination="tableData.pagination"
        :columns="tableData.columns"
        :rowKey="record => record.id"
        :dataSource="tableData.data"
        :loading="tableData.loading"
        @change="handleTableChange"
      >
      </a-table>
    </a-row>

  </div>
</template>

<script>
// import { xxx } from '@/api/xxx'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (val) {
        console.log('触发', val)
        this.clear()
        this.initData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      tableData: {
        data: [],
        columns: [
          {
            title: '序号',
            dataIndex: 'xxx1',
            align: 'left',
            width: '5%'
          },
          {
            title: '定检周期（月）',
            dataIndex: 'xxx2',
            align: 'left',
            width: '15%'
          },
          {
            title: '上次检定时间',
            dataIndex: 'xxx3',
            align: 'left',
            width: '20%'
          },
          {
            title: '下次检定时间',
            dataIndex: 'xxx4',
            align: 'left',
            width: '20%'
          },
          {
            title: '检定单位',
            dataIndex: 'xxx5',
            align: 'left',
            width: '20%'
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          showQuickJumper: true
        },
        loading: false
      }
    }
  },
  methods: {
    async initData () {
      this.tableData.loading = true
      for (let i = 0; i < 99; i++) {
        this.tableData.data.push({
          id: i,
          xxx1: 'xxx' + i,
          xxx2: 'xxx' + i,
          xxx3: 'xxx' + i,
          xxx4: 'xxx' + i,
          xxx5: 'xxx' + i
        })
      }
      // const { current, pageSize } = this.tableData.pagination
      // const params = { pageNum: current, pageSize }
      // const res = await xxxx(params)
      // if (res && res.status === 0) {
      //   this.tableData.data = res.data.list
      //   this.tableData.pagination.total = res.data.total
      // } else {
      //   this.$message.error(res.info.message)
      // }
      this.tableData.loading = false
    },
    handleTableChange (pagination) {
      this.tableData.pagination.pageSize = pagination.pageSize
      this.tableData.pagination.current = pagination.current
      this.initData()
    },
    clear () {
      this.tableData.data = []
      this.tableData.pagination = {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      }
    },
    showDetail () {}
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-thead{
  height: 32px;
  & th{
    background: #E6ECF5;
  }
}
.mb-10{
  margin-bottom: 10px;
}
</style>
